import { RootState } from '@/store';
import { api } from '../core';
import { getCaseDocuments } from '../case';

export type DocumentUploadCompleteResponse = object;

type DocumentUploadCompleteProps = {
  abortController?: AbortController;
  documentId: string;
};

const documentUploadCompleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postDocumentUploadComplete: builder.query<DocumentUploadCompleteResponse, DocumentUploadCompleteProps>({
      query: ({ abortController = new AbortController(), documentId }: DocumentUploadCompleteProps) => ({
        url: `document/upload-complete`,
        method: 'POST',
        body: {
          document_id: documentId
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;
          const state = getState() as RootState;

          if (
            typeof state.case.caseId === 'string' &&
            state.caseDocuments.caseDocumentsPagination.pageIndex >= 0 &&
            state.caseDocuments.caseDocumentsPagination.pageSize > 0
          ) {
            dispatch(
              getCaseDocuments.initiate(
                {
                  caseId: state.case.caseId,
                  pageIndex: state.caseDocuments.caseDocumentsPagination.pageIndex,
                  pageSize: state.caseDocuments.caseDocumentsPagination.pageSize
                },
                {
                  forceRefetch: true
                }
              )
            );
          }
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postDocumentUploadComplete in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyPostDocumentUploadCompleteQuery } = documentUploadCompleteApi;
